import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';
import { Sizes } from '../../../common/Models/Enums';
import { getSizes } from '../../../common/utils/utils';

@Component({
  selector: 'skc-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.less']
})
export class ParagraphComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-width') width = '100%';
  @Input('skc-title-height') titleHeight: string;
  @Input('skc-title') title = true;
  @Input('skc-rows') rows = 3;
  @Input('skc-paragraph') paragraph = true;
  @Input('skc-last-sentence-width') lastSentenceWidth = '61%';
  @Input('skc-title-width') titleWidth = '38%';
  @Input('size-sentence') sizeSentence: Sizes = Sizes.MIDDLE;
  rowsParagraph = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.rowsParagraph = new Array(this.rows <= 0 ? 3 : this.rows);
  }

  public get Height(): string {
    if (this.height) {
      return this.height;
    } else {
      switch (this.sizeSentence) {
        case Sizes.SMALL:
          return getSizes(this.sizeSentence);
        case Sizes.MIDDLE:
          return getSizes(this.sizeSentence);
        case Sizes.LARGE:
          return getSizes(this.sizeSentence);
      }
    }
  }

  public get TitleHeight(): string {
    if (this.titleHeight) {
      return this.height;
    } else {
      switch (this.sizeSentence) {
        case Sizes.SMALL:
          return getSizes(this.sizeSentence);
        case Sizes.MIDDLE:
          return getSizes(this.sizeSentence);
        case Sizes.LARGE:
          return getSizes(this.sizeSentence);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rows && !changes.rows.firstChange) {
      this.rowsParagraph = new Array(changes.rows.currentValue <= 0 ? 3 : changes.rows.currentValue);
    }
  }
}
